// extracted by mini-css-extract-plugin
module.exports = {"container":"propertyFeatureCardSrps_container__3Za6k","content":"propertyFeatureCardSrps_content__1alZa","img":"propertyFeatureCardSrps_img__2KVt-","price":"propertyFeatureCardSrps_price__G1NHZ"};
    if(module.hot) {
      // 1790670298581
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  